export { default } from "./info-tooltip";
